/* ------------------------------------------------------------------
   Cactus Corn conversion fixes bootstrap, added Aug 1 2026.
   custom.js already loads on every page, so this is the cheapest
   global entry point. It loads two clearly named files:
     assets/cc-cro-fixes.css
     assets/cc-cro-fixes.js
   Nothing else in this file was changed. The original carousel
   code is below, byte for byte.

   TO ROLL BACK: delete this one block. Nothing else depends on it.

   NOTE FOR LATER: the tidier long-term home for these two tags is
   layout/theme.liquid, right after the custom.css stylesheet_tag.
   A ready-made snippet already exists at snippets/cc-cro-head.liquid.
   Kept here for now to avoid editing the layout file that carries the
   Meta pixel and all the JSON-LD schema.
   ------------------------------------------------------------------ */
(function () {
  try {
    if (window.__ccCroBootstrapped) return;
    window.__ccCroBootstrapped = true;

    var me = document.currentScript;
    var src = me && me.src ? me.src : '';
    var base = src ? src.replace(/custom\.js.*$/, '') : '';
    if (!base) return;

    if (!document.querySelector('link[href*="cc-cro-fixes.css"]')) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = base + 'cc-cro-fixes.css';
      document.head.appendChild(l);
    }

    if (!document.querySelector('script[src*="cc-cro-fixes.js"]')) {
      var s = document.createElement('script');
      s.src = base + 'cc-cro-fixes.js';
      s.defer = true;
      document.head.appendChild(s);
    }
  } catch (e) {
    if (window.console) console.warn('[cc-cro] bootstrap failed:', e);
  }
})();

/* ---------------- original theme code, unchanged ---------------- */
$(document).ready(function(){

$('.owl-carousel').owlCarousel({
    loop:true,
    margin:40,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        600:{
            items:3,
            nav:false,
          margin:0,
        },
        1000:{
            items:4,
            nav:true,
            loop:false
        }
    }
})


});